import { useDispatch, useSelector } from "react-redux";
import { Close } from "src/components/svg";
import { DateService, _ } from "src/services";
import { TvModel, TvAction } from "src/store";

export const TvModelDatePicker: React.FC<{ toggleCalendar: () => void }> = ({ toggleCalendar }) => {

    const dispatch = useDispatch();
    const weeks = DateService.getTvDates();
    const conductor: TvModel = useSelector((state: any) => state.TvState);

    const onSelectDate = (d: any) => {
        if (!d.active) return;

        toggleCalendar();

        const date = DateService.gregorianDate(d.year, d.month, d.day);
        dispatch(TvAction.setCurrentDate(date));
    };

    const isSelected = (d: any) => {
        const date = DateService.gregorianDate(d.year, d.month, d.day);

        if (!conductor.currentDate && d.today) return true;

        return date.getTime() === conductor.currentDate?.getTime();
    };

    return (
        <div className="date-picker">
            <div className="header">
                <div className="cursor-pointer position-absolute close d-lg-none" onClick={toggleCalendar}>
                    <Close />
                </div>
                <div className="title d-lg-none">{_("chooseYourDay")}</div>
                <div className="header-row">
                    {DateService.daysTitle.map((x, index) => (
                        <div className="header-row-cell" key={index}>{x}</div>
                    ))}
                </div>
            </div>
            <table className="table-days" cellPadding={0}>
                <tbody>
                    {
                        weeks.map((w, i) => (
                            <tr key={i}>
                                {
                                    w.map((d, j) => {
                                        const className =
                                            (!d.active ? "other-month" : isSelected(d) ? "selected" : "") +
                                            (d.today ? " today" : "");
                                        return (
                                            <td key={j} className={className} onClick={() => onSelectDate(d)}>
                                                <span >{d.title}</span>
                                            </td>
                                        );
                                    })
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );

};